// Generated by CoffeeScript 2.7.0
var Journey;

import BaseModel from '../base_model.js';

export default Journey = (function() {
  class Journey extends BaseModel {};

  Journey.setAttributes(['status']);

  return Journey;

}).call(this);
